<template>
    <!-- Desplegable de filtro con buscador (sin <select> del navegador).
         opciones: [{ v, t, n }]; '' = todos. -->
    <div class="es-dd">
        <button ref="btn" type="button" class="es-dd-btn" :class="{ 'is-on': !!value }" aria-haspopup="listbox" :aria-expanded="String(abierto)" @click="alternar">
            <small>{{ etiqueta }}:</small><span class="es-dd-v">{{ actual }}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
        </button>
        <div v-if="abierto" ref="pop" class="es-pop" :style="pos" role="dialog" :aria-label="etiqueta" @keydown="tecla">
            <div v-if="opciones.length > 7" class="es-pop-q">
                <input ref="q" v-model="q" type="search" :placeholder="'Buscar ' + etiqueta.toLowerCase() + '…'" autocomplete="off" :aria-label="'Buscar ' + etiqueta" />
            </div>
            <div class="es-pop-list" role="listbox" :aria-label="etiqueta">
                <button type="button" class="es-pop-item" role="option" :aria-selected="String(!value)" @click="elegir('')"><span>{{ todos }}</span></button>
                <button v-for="o in visibles" :key="o.v" type="button" class="es-pop-item" role="option" :aria-selected="String(o.v === value)" @click="elegir(o.v)">
                    <span :title="o.t">{{ o.t }}</span><small v-if="o.n !== undefined">{{ cifra(o.n) }}</small>
                </button>
                <p v-if="!visibles.length" class="es-pop-none">Sin resultados</p>
            </div>
        </div>
    </div>
</template>

<script>
const norm = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export default {
    name: 'EstSelect',
    props: {
        value: { type: String, default: '' },
        etiqueta: { type: String, required: true },
        todos: { type: String, default: 'Todos' },
        opciones: { type: Array, default: () => [] },
    },
    data() { return { abierto: false, q: '', pos: {} }; },
    computed: {
        actual() { const o = this.opciones.find(x => x.v === this.value); return o ? o.t : (this.value ? this.value : this.todos); },
        visibles() { const q = norm(this.q).trim(); return (q ? this.opciones.filter(o => norm(o.t).includes(q)) : this.opciones).slice(0, 300); },
    },
    beforeDestroy() { this.cerrar(); },
    methods: {
        cifra(n) { return Number(n).toLocaleString('es-CL'); },
        alternar() { if (this.abierto) this.cerrar(); else this.abrir(); },
        abrir() {
            const r = this.$refs.btn.getBoundingClientRect(), w = 300;
            const left = Math.max(8, Math.min(r.left, innerWidth - w - 8));
            const abajo = innerHeight - r.bottom > 260;
            this.pos = abajo ? { left: left + 'px', top: (r.bottom + 6) + 'px' } : { left: left + 'px', bottom: (innerHeight - r.top + 6) + 'px' };
            this.abierto = true; this.q = '';
            this.$nextTick(() => {
                const el = this.$refs.q || (this.$refs.pop && this.$refs.pop.querySelector('[aria-selected="true"]'));
                if (el) el.focus();
            });
            this._fuera = e => { if (!this.$el.contains(e.target)) this.cerrar(); };
            this._mover = e => { if (!this.$refs.pop || !this.$refs.pop.contains(e.target)) this.cerrar(); };
            setTimeout(() => { document.addEventListener('mousedown', this._fuera, true); window.addEventListener('scroll', this._mover, true); window.addEventListener('resize', this._mover); }, 0);
        },
        cerrar(enfocar) {
            if (!this.abierto) return;
            this.abierto = false;
            document.removeEventListener('mousedown', this._fuera, true);
            window.removeEventListener('scroll', this._mover, true);
            window.removeEventListener('resize', this._mover);
            if (enfocar && this.$refs.btn) this.$refs.btn.focus();
        },
        elegir(v) { this.$emit('input', v); this.cerrar(true); },
        tecla(e) {
            if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); this.cerrar(true); return; }
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
            e.preventDefault();
            const its = [...this.$refs.pop.querySelectorAll('.es-pop-item')], i = its.indexOf(document.activeElement);
            const j = e.key === 'ArrowDown' ? Math.min(its.length - 1, i + 1) : Math.max(0, i - 1);
            if (its[j]) its[j].focus();
        },
    },
};
</script>
